import React from "react";
import { TrainingTopic } from "../../types/TrainingTopic";
import { Container, Button } from "@material-ui/core";
import TrainingQuestion from "./TrainingQuestion";
import Question, { QuestionType } from "../../types/Question";
import { CompanyContext } from "../../context/CompanyContext";

interface IProps {
  topic: TrainingTopic;
  onContinue: (score: number) => void;
  updateTopic: (score: number) => void;
}

export default function TrainingAssessment(props: IProps) {
  const { topic, onContinue, updateTopic } = props;
  const assessment = topic.assessment;
  const [questions, setQuestions] = React.useState<Array<Question>>([]);
  const [message, setMessage] = React.useState("");
  const [showContinue, setShowContinue] = React.useState(false);
  const [score, setScore] = React.useState(0);
  const company = React.useContext(CompanyContext);

  React.useEffect(() => {
    if (assessment) {
      setQuestions(assessment.questions);
      setShowContinue(false);
      setMessage("");
    }
  }, [assessment]);

  function onChange(index: number, question: Question) {
    let array = Array.from(questions);
    array[index] = question;
    setQuestions(array);
  }

  function handleSubmit() {
    let numCorrect = 0;
    let questionsArray = Array.from(questions ?? []);
    let numQuestions = 0;
    for (let question of questionsArray) {
      if (question.active) {
        numQuestions++;
        if (question.questionType !== QuestionType.Essay) {
          question.status = "correct";
          if (question.answers) {
            for (let answer of question.answers) {
              if (
                (answer.selectedAnswer || answer.correctAnswer) &&
                answer.selectedAnswer !== answer.correctAnswer
              ) {
                if (question.questionType === QuestionType.WithResponse) {
                  if (
                    answer.selectedAnswer === true &&
                    (answer.promptAnswer === undefined ||
                      answer.promptAnswer?.length === 0)
                  ) {
                    question.status = "wrong";
                  }
                } else {
                  question.status = "wrong";
                }
              }
            }
          }
        } else {
          question.status = "correct";
        }
        if (question.status === "correct") numCorrect++;
      }
    }
    setQuestions(questionsArray);
    let score = Math.round((numCorrect / numQuestions) * 100);
    setScore(score);
    setMessage(`You got a score of ${score}%`);

    const passed = score >= (assessment?.passingScore ?? 0);
    setShowContinue(passed);
    updateTopic(score);
    if (passed) {
      onContinue(score);
    }
  }

  function continueSubmit() {
    onContinue(score);
  }

  function resetForm() {
    setMessage("");
    let questionsArray = Array.from(questions);
    for (let question of questionsArray) {
      if (company.repeatOnlyMissedQuestion) {
        if (question.status === "wrong") {
          resetQuestion(question);
        }
      } else {
        resetQuestion(question);
      }
    }
    setQuestions(questionsArray);
  }

  function resetQuestion(question: Question) {
    question.status = "";
    if (question.answers) {
      for (let answer of question.answers) {
        answer.selectedAnswer = false;
      }
    }
  }

  return (
    <Container maxWidth="lg" style={{ paddingBottom: 32 }}>
      <h2 style={{ marginBottom: 5 }}>{topic.topicTitle}</h2>
      <h4 style={{ marginTop: 5 }}>
        Passing score: {assessment?.passingScore}%
      </h4>
      {questions &&
        questions.map((question, index) => (
          <div key={index}>
            {question.active ? (
              <TrainingQuestion
                question={question}
                index={index}
                onChange={onChange}
                key={index}
              />
            ) : null}
          </div>
        ))}
      {message ? (
        <>
          <h2>{message}</h2>
          {showContinue ? (
            <Button
              variant="contained"
              color="primary"
              onClick={continueSubmit}
              style={{ marginTop: 10, width: 170 }}
            >
              Continue
            </Button>
          ) : (
            <Button
              variant="contained"
              color="primary"
              onClick={resetForm}
              style={{ marginTop: 10, width: 170 }}
            >
              Try Again
            </Button>
          )}
        </>
      ) : (
        <div className="buttons-container">
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            style={{ marginTop: 10 }}
          >
            Submit
          </Button>
        </div>
      )}
    </Container>
  );
}
